import { ChakraProps, Image } from '@chakra-ui/react';
import { CMS } from '@waitroom/models';

import Video from '@core/components/Video/Video';
import { commonConfig } from '@core/config';
import { getFileUrl, getImageUrl } from '../../utils/base';
import FullLengthVideo from '../FullLengthVideo';

const videoProps = {
  rounded: '1.2rem',
  overflow: 'hidden',
} as const;

export interface CmsVideoOrImageProps extends ChakraProps {
  video?: CMS.Video;
  image?: CMS.Image;
  size?: [number, number];
  fallbackSrc?: string;
}

const CmsVideoOrImage = ({
  video,
  image,
  size,
  fallbackSrc,
  ...rest
}: CmsVideoOrImageProps): React.ReactElement | null => {
  const { file, fileFull } = video || {};
  const videoUrl = getFileUrl(file?.asset?._ref);
  const fullUrl = getFileUrl(fileFull?.asset?._ref);
  const imageUrl = image
    ? getImageUrl(image.asset?._ref, size ? ['fit=crop', `w=${size[0]}`, `h=${size[1]}`] : [])
    : undefined;

  return (
    <>
      {videoUrl ? (
        fullUrl ? (
          <FullLengthVideo
            video={videoUrl}
            fullVideo={fullUrl}
            poster={imageUrl}
            autoplay={!!video && !!video.autoplay}
            {...rest}
          />
        ) : (
          <Video
            video={[{ src: `${videoUrl}`, type: 'video/mp4' }]}
            poster={imageUrl}
            autoPlay={!!video && !!video.autoplay}
            lazy
            loop
            muted
            playsInline
            {...videoProps}
            {...rest}
          />
        )
      ) : imageUrl ? (
        <Image
          src={imageUrl}
          fallbackSrc={fallbackSrc}
          alt={commonConfig.company.name}
          loading="lazy"
          rounded="xl"
          {...rest}
        />
      ) : null}
    </>
  );
};
export default CmsVideoOrImage;
